import React from "react";
import PropTypes from "prop-types";
import MDButton from "../MDButton";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";

const ExportToExcelMonitoring = ({ data, columns, fileName }) => {
    const exportToCSV = () => {
        const headerRows = [];
        const processedHeaders = new Set(); // Keep track of processed headers

        const extractHeaderRows = (columns, parentTitle = '') => {
            columns.forEach(column => {
                const header = parentTitle ? `${parentTitle} - ${column.title}` : column.title;
                if (!processedHeaders.has(header)) { // Check if header is not processed yet
                    processedHeaders.add(header);
                    if (column.children) {
                        extractHeaderRows(column.children, column.title); // Recursive call for children
                    } else {
                        headerRows.push(header);
                    }
                }
            });
        };

        extractHeaderRows(columns);

        // Combine parent and child headers into one array
        const allHeaders = [...headerRows];

        // Construct header row with colspans
        const headerRow = ['Sr. No.', ...allHeaders].join(',');

        // Extracting data values from the data array
        const dataRows = data.map((row, index) => {
            const serialNumber = index + 1;
            const rowData = columns.map(column => {
                const extractData = (children) => {
                    return children.map(child => {
                        if (child.children) {
                            return extractData(child.children);
                        } else {
                            if (child.dataIndex === 'Created_Dt') {
                                // Format date if exists
                                return row[child.dataIndex] ? moment(row[child.dataIndex]).format('DD/MM/YYYY') : '';
                            } else {
                                // Show blank if value is "null"
                                return row[child.dataIndex] === 'null' ? '' : row[child.dataIndex];
                            }
                        }
                    }).join(',');
                };

                if (column.children) {
                    return extractData(column.children);
                } else {
                    if (column.dataIndex === 'Created_Dt') {
                        // Format date if exists
                        return row[column.dataIndex] ? moment(row[column.dataIndex]).format('DD/MM/YYYY') : '';
                    } else {
                        // Show blank if value is "null"
                        return row[column.dataIndex] === 'null' ? '' : row[column.dataIndex];
                    }
                }
            }).join(',');

            return `${serialNumber},${rowData}`; // Adding serial number to the row
        });

        const csvContent = "data:text/csv;charset=utf-8," + headerRow + "\n" + dataRows.join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);

        link.click();
    };

    return (
        <MDButton onClick={exportToCSV} variant="contained" icon={<DownloadOutlined />}>
            Export CSV
        </MDButton>
    );
};

ExportToExcelMonitoring.propTypes = {
    data: PropTypes.array.isRequired,
    fileName: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
};

export default ExportToExcelMonitoring;
